import { createConsts, createActions } from '../../utils/redux';

export const consts = createConsts('ui', 'createChat', 'TOGGLE_VISIBILITY');
export const actions = createActions(consts);

const initialState = {
  visible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: !state.visible,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/createchat.js